module.exports = __webpack_public_path__ + "img/61c5c821-1366-485d-b3a8-7f34e161e6c9.88de2fcb.png";